import React from "react";
import {
  Card,
  IllustrationArea,
  Label,
  PreviewImage,
} from "./BlankCanvasCard.styles";
import type { BlankCanvasCardProps } from "./BlankCanvasCard.types";

export const BlankCanvasCard: React.FC<BlankCanvasCardProps> = ({
  label = "Blank canvas",
  onSelect,
  disabled = false,
  selected,
  className,
}) => (
  <Card
    type="button"
    className={className}
    disabled={disabled}
    aria-pressed={selected}
    onClick={onSelect}
  >
    <Label title={label}>{label}</Label>
    <IllustrationArea aria-hidden="true">
      <PreviewImage
        src="/blank-canvas-card/preview.svg"
        alt=""
        data-testid="blank-canvas-preview"
      />
    </IllustrationArea>
  </Card>
);

export default BlankCanvasCard;
